// Shopify Inbox owns this label; its preset is not exposed in Translate & Adapt.
// Keep this override scoped to the current Inbox activator and Latvian pages.
(() => {
  if (document.documentElement.lang.toLowerCase().split('-')[0] !== 'lv') return;

  const translation = 'Vajag palīdzību?';
  const watched = new WeakSet();

  function watchChat(chat) {
    const root = chat.shadowRoot;
    if (!root || watched.has(chat)) return;
    watched.add(chat);

    function translateButton() {
      const label = root.querySelector('.activator__label');
      const button = root.querySelector('button.activator');
      if (!label || !button || label.hidden) return;
      const text = label.textContent.trim();
      if (text !== 'Need help?' && text !== translation) return;
      if (text !== translation) label.textContent = translation;
      if (button.getAttribute('aria-label') !== translation) {
        button.setAttribute('aria-label', translation);
      }
    }

    // Inbox can rebuild its activator after opening or closing the chat.
    new MutationObserver(translateButton).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'hidden'],
    });
    translateButton();
  }

  customElements.whenDefined('shopify-chat').then(() => {
    function findChats() {
      document.querySelectorAll('shopify-chat').forEach(watchChat);
    }
    findChats();
    // Also handle delayed app embeds and theme-editor replacement of the widget.
    new MutationObserver(findChats).observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
})();
